import {Button, CheckIcon, CrossIcon, ModalPopup} from '@kit';

import React, {useCallback, useEffect, useRef, useState} from 'react';
import set = Reflect.set;

import {cls} from '../utils';

import pageCss from '../page.module.css';

type Props = {
	onConfirm: () => void;
	onCancel: () => void;
	open: boolean;
	text: string | React.ReactNode;
	title?: string | React.ReactNode;
};

type UseProps = {
	callback: (variables?: any) => void;
	text?: string | React.ReactNode;
	title?: string | React.ReactNode;
};

const DeleteConfirm: React.FC<Props> = ({open, title, text, onCancel, onConfirm}) => {
	const okRef = useRef<any>(null);
	useEffect(() => {
		if (okRef.current) okRef.current.focus();
	}, [open]);

	return (
		<ModalPopup open={open} onClose={onCancel} maxWidth={400}>
			<p className={'modal-popup-form'}>
				<h1>{title || 'Удалить объект'}</h1>
				{text}
			</p>

			<ul className={cls('modal-popup-buttons', pageCss.formButtons)}>
				<li>
					<Button icon={<CrossIcon width={24} height={24} />} onClick={onCancel}>
						Нет
					</Button>
				</li>
				<li>
					<Button
						appearance="primary"
						icon={<CheckIcon width={24} height={24} />}
						setRef={okRef}
						onClick={onConfirm}
					>
						Да
					</Button>
				</li>
			</ul>
		</ModalPopup>
	);
};

export const useDeleteConfirm = ({callback, title, text}: UseProps) => {
	const [open, setOpen] = useState(false);
	const [variables, setVariables] = useState<any>();

	const handleCancel = useCallback(() => {
		setOpen(false);
	}, []);

	const handleConfirm = useCallback(() => {
		setOpen(false);
		callback(variables);
	}, [callback, variables]);

	const handleOpenConfirm = useCallback((variables?: any) => {
		setOpen(true);
		if (variables) setVariables(variables);
	}, []);

	return {
		openConfirm: handleOpenConfirm,
		DeleteConfirm: (
			<DeleteConfirm
				text={text || 'Вы уверены?'}
				title={title}
				onConfirm={handleConfirm}
				onCancel={handleCancel}
				open={open}
			/>
		),
	};
};
